import { GapCategory } from './gapThresholds'

export const GAP_IMPLICATIONS: Record<GapCategory, { implications: string[] }> = {
  High: {
    implications: [
      'High strategic clarity',
      'First-mover or category-defining presence',
      'Little immediate competition',
      'Strong market signal to investors',
    ],
  },
  Moderate: {
    implications: [
      'Clear advantage, but being noticed',
      'Competitors may be mobilising',
      'May indicate an emerging trend',
      'Opportunity to consolidate before competition intensifies',
    ],
  },
  Low: {
    implications: [
      'Innovation space is crowded',
      'Differentiation is limited',
      'Position under pressure',
      'May indicate mature or saturated area',
    ],
  },
  Negative: {
    implications: [
      'Target may be losing focus or over-diversified',
      'A rival may be better placed to dominate the space',
      'Risk of being outmanoeuvred',
      'Requires deeper due diligence',
    ],
  },
}
